// Moved from templates/components/scripts/tealium-page-processors.html (Phase 3D webpack extraction)
// All HBS template expressions replaced with window.LG_PAGE_DATA / window.BC_CONTEXT reads.

export function tealiumGetCartItemsNames() {
    try {
        const items = window.LG_PAGE_DATA?.cartItems || [];
        const nameArrayStart = [];
        // Preserve original behavior: push all names concatenated as a single string element
        nameArrayStart.push(items.map(i => i.name || '').join(''));
        return nameArrayStart;
    } catch(ex) {
        //console.log("error: ", ex);
    }
    return 'false';
}


export function breadcrumbToCategories() {
    const breadcrumbs = window.LG_PAGE_DATA?.breadcrumbs || [];
    const breadcrumbArray = breadcrumbs.map(b => b.name).filter(Boolean);

    if (!breadcrumbArray || breadcrumbArray.length === 0) {
        return { categoryCurrent: undefined, subCategoryCurrent: undefined };
    }

    let categoryCurrent, subCategoryCurrent;
    const pageType = window.BC_CONTEXT?.pageType || '';

    if (pageType === "product") {
        categoryCurrent = breadcrumbArray[1];
        subCategoryCurrent = breadcrumbArray[breadcrumbArray.length - 2];
    } else if (pageType === "category") {
        categoryCurrent = breadcrumbArray[1];
        subCategoryCurrent = breadcrumbArray[breadcrumbArray.length - 1];
    } else if (pageType === "brand" || pageType === "brands") {
        categoryCurrent = "Brands";
        subCategoryCurrent = breadcrumbArray[1];
    } else if (breadcrumbArray.length >= 2) {
        categoryCurrent = breadcrumbArray[0];
        subCategoryCurrent = breadcrumbArray[1];
    } else if (breadcrumbArray.length === 1) {
        categoryCurrent = breadcrumbArray[0];
        subCategoryCurrent = breadcrumbArray[0];
    } else {
        categoryCurrent = undefined;
        subCategoryCurrent = undefined;
    }

    return { categoryCurrent, subCategoryCurrent };
}


export function initializeUtagDataWithCustomer() {
    const customer = window.LG_PAGE_DATA?.customer;
    const gqlCustomer = window.LG_PAGE_DATA?.gqlCustomer;

    const login = Boolean(customer);
    let utagData = {
        customer_first_name: "",
        customer_last_name: "",
        registration_flag: [],
        login_flag: 'false',
        customer_email: gqlCustomer?.email || '',
        is_logged_in: String(login),
        page_name: '',
        tealium_event: ''
    };

    const fullName = customer?.name || '';
    if (fullName) {
        const nameSplit = fullName.split(' ');
        utagData.customer_first_name = nameSplit[0] || "";
        utagData.customer_last_name = nameSplit[1] || "";
        utagData.registration_flag.push('true');
    }

    if (login === true || login === 'True') {
        utagData.registration_flag = ['True', 'True'];
        utagData.login_flag = 'True';
        utagData.is_logged_in = 'true';
    } else {
        utagData.registration_flag = ['False', 'False'];
    }

    if (!utagData.customer_first_name) {
        utagData.customer_first_name = gqlCustomer?.firstName || '';
        utagData.customer_last_name = gqlCustomer?.lastName || '';
    }

    if (utagData.is_logged_in === 'false') {
        utagData.is_logged_in = String(Boolean(utagData.customer_email));
        utagData.login_flag = String(Boolean(utagData.customer_email));
    }
    return utagData;
}


export function processHomePageUtagData(utag_data) {
    utag_data.page_name = 'Home';
    utag_data.tealium_event = 'home';
    return utag_data;
}


export function processCartPageUtagData(utag_data, breadcrumbCategories, productIdArray, quantityNameArray, urlArray, priceArray, nameArray, categoryArray) {
    const { categoryCurrent: Cat, subCategoryCurrent: subCat } = breadcrumbCategories;
    const cartGrandTotal = window.LG_PAGE_DATA?.cartGrandTotal || '';

    let rootCategories = [];
    let subCategories = [];
    if (categoryArray && Array.isArray(categoryArray)) {
        categoryArray.forEach(category => {
            if (category) {
                let parts = category.split('/');
                let rootCategory = parts[0];
                let subCategory = parts.slice(1).join('/');
                if (!rootCategories.includes(rootCategory)) {
                    rootCategories.push(rootCategory);
                }
                if (subCategory && !subCategories.includes(subCategory)) {
                    subCategories.push(subCategory);
                }
            }
        });
    }

    utag_data = {
        ...utag_data,
        cart_product_sku: productIdArray,
        cart_product_quantity: quantityNameArray,
        cart_product_id: productIdArray,
        cart_product_image_url: urlArray,
        cart_product_name: nameArray,
        cart_product_url: urlArray,
        cart_product_price: priceArray,
        cart_total: cartGrandTotal,
        cart_product_category: rootCategories,
        cart_product_subcategory: subCategories,

        product_sku: productIdArray,
        product_quantity: quantityNameArray,
        product_id: productIdArray,
        product_image_url: urlArray,
        product_name: nameArray,
        product_url: urlArray,
        product_price: priceArray,
        total: cartGrandTotal,
        product_category: rootCategories,
        product_subcategory: subCategories,

        page_category: Cat,
        page_subcategory: subCat,

        page_name: window.BC_CONTEXT?.pageType || '',
        customer_first_name: utag_data.customer_first_name,
        customer_last_name: utag_data.customer_last_name,
        customer_phone: window.LG_PAGE_DATA?.customer?.phone || '',
        tealium_event: 'cart',
    };

    if (Cat) {
        utag_data.page_category = Cat;
    }
    if (subCat) {
        utag_data.page_subcategory = subCat;
    }

    return utag_data;
}


export function processPageTypePageUtagData(utag_data, pageTitle, uniqueId) {
    utag_data = {
        ...utag_data,
        page_name: pageTitle,
        tealium_event: 'content',
    };
    if (uniqueId != null) {
        utag_data.user_id = uniqueId;
    }
    return utag_data;
}


export function processProductPageUtagData(utag_data, breadcrumbCategories) {
    const { categoryCurrent: Cat, subCategoryCurrent: subCat } = breadcrumbCategories;
    const siteObject = window.LG_PAGE_DATA?.gqlSite;
    const product = window.LG_PAGE_DATA?.product || {};
    const gqlCustomer = window.LG_PAGE_DATA?.gqlCustomer;

    utag_data = {
        ...utag_data,
        cart_product_sku: [],
        cart_product_quantity: [],
        cart_product_id: [],
        cart_product_image_url: [],
        cart_product_name: [],
        cart_product_url: [],
        cart_product_price: [],
        cart_total: siteObject?.cart?.amount?.value || '',
        page_category: Cat,
        page_subcategory: subCat,
        ip_address: window.BC_CONTEXT?.client_ip_address || '',
        product_brand: [product.brand || ''],
        product_category: [Cat],
        product_id: [product.sku || ''],
        product_sku: [product.sku || ''],
        product_subcategory: [subCat],
        product_variant: [],
        product_quantity: [1],
        product_image_url: [product.image || ''],
        product_name: [product.title || ''],
        product_url: product.url || '',
        product_price: [product.price || ''],
        page_name: product.title || '',
        total: siteObject?.cart?.amount?.value ? String(siteObject.cart.amount.value) : '',
        customer_phone: gqlCustomer?.phone || '',
        tealium_event: 'product_detail',
    };

    if (siteObject?.cart?.lineItems?.physicalItems) {
        siteObject.cart.lineItems.physicalItems.forEach(item => {
            utag_data.cart_product_sku.push(item.sku);
            utag_data.cart_product_id.push(item.sku);
            utag_data.cart_product_quantity.push(item.quantity);
            utag_data.cart_product_image_url.push(item.imageUrl);
            utag_data.cart_product_name.push(item.name);
            utag_data.cart_product_url.push(item.url);
            utag_data.cart_product_price.push(item.salePrice?.value);
        });
        utag_data.cart_total = siteObject.cart.amount?.value;
    }

    if (gqlCustomer?.addresses?.edges?.length > 0) {
        utag_data.customer_city = gqlCustomer.addresses.edges[0].node.city;
    }

    return utag_data;
}


export function processBrandPageUtagData(utag_data, breadcrumbCategories, categoryProductArray) {
    const { categoryCurrent: Cat, subCategoryCurrent: subCat } = breadcrumbCategories;
    const cartGrandTotal = window.LG_PAGE_DATA?.cartGrandTotal || '';
    const customer = window.LG_PAGE_DATA?.customer;

    utag_data = {
        ...utag_data,
        cart_total: cartGrandTotal,
        ip_address: window.BC_CONTEXT?.client_ip_address || '',
        page_category: Cat,
        page_subcategory: subCat,
        page_name: window.LG_PAGE_DATA?.brand?.name || '',
        total: cartGrandTotal,
        customer_phone: customer?.phone || '',
        customer_city: customer?.shipping_address?.city || '',
        customer_id: customer?.id ? String(customer.id) : '',
        customer_state: customer?.shipping_address?.state || '',
        customer_zip: customer?.shipping_address?.zip || '',
        customer_country: customer?.shipping_address?.country_id || '',
        checkout_step_name: '',
        checkout_step_number: '',
        tealium_event: 'product_listing',
        //products_displayed: categoryProductArray,
    };

    if (utag_data.page_name === "") {
        utag_data.page_name = 'All Brands';
    }
    if (Cat) {
        utag_data.page_category = Cat;
    }
    if (subCat) {
        utag_data.page_subcategory = subCat;
    }

    return utag_data;
}


export function processCategoryPageUtagData(utag_data, breadcrumbCategories, queryParams, categoryArray, categoryProductArray) {
    const { categoryCurrent: Cat, subCategoryCurrent: subCat } = breadcrumbCategories;
    const cartGrandTotal = window.LG_PAGE_DATA?.cartGrandTotal || '';
    const customer = window.LG_PAGE_DATA?.customer;
    // category.seoKeywords || page.title || category.name — mirrors the original HBS conditional
    const pageName = window.LG_PAGE_DATA?.category?.seoKeywords
        || window.LG_PAGE_DATA?.page?.title
        || window.LG_PAGE_DATA?.category?.name
        || '';

    let rootCategories = [];
    let subCategories = [];
    categoryArray.forEach(category => {
        let parts = category.split('/');
        let rootCategory = parts[0];
        let subCategory = parts.slice(1).join('/');
        if (!rootCategories.includes(rootCategory)) {
            rootCategories.push(rootCategory);
        }
        if (subCategory && !subCategories.includes(subCategory)) {
            subCategories.push(subCategory);
        }
    });

    if (typeof queryParams.searchQuery !== "undefined") {
        utag_data = {
            ...utag_data,
            search_keyword: queryParams.searchQuery,
            search_facet: String(queryParams.facetSelect || []),
            search_keyword_fallback: queryParams.searchQueryFallback || '',
            page_name: pageName,
            search_results: "",
            search_page: queryParams.pageNumber,
            tealium_event: 'search results',
        };
    } else {
        utag_data = {
            ...utag_data,
            cart_total: cartGrandTotal,
            cart_product_category: rootCategories,
            cart_product_subcategory: subCategories,
            cart_product_category_id: [],
            cart_product_subcategory_id: [],
            page_category: Cat,
            page_subcategory: subCat,
            ip_address: window.BC_CONTEXT?.client_ip_address || '',
            product_category: [Cat],
            product_subcategory: [subCat],
            page_name: pageName,
            total: cartGrandTotal,
            customer_phone: customer?.phone || '',
            customer_city: customer?.shipping_address?.city || '',
            customer_id: customer?.id ? String(customer.id) : '',
            customer_state: customer?.shipping_address?.state || '',
            customer_zip: customer?.shipping_address?.zip || '',
            customer_country: customer?.shipping_address?.country_id || '',
            checkout_step_name: '',
            checkout_step_number: '',
            tealium_event: 'product_listing',
            //products_displayed: categoryProductArray,
            search_page: queryParams.pageNumber,
        };
    }
    return utag_data;
}


export function process404PageUtagData(utag_data, breadcrumbObject, categoryProductArray, uniqueId) {
    const cartGrandTotal = window.LG_PAGE_DATA?.cartGrandTotal || '';
    const customer = window.LG_PAGE_DATA?.customer;

    let Cat;
    let subCat;
    if (breadcrumbObject && breadcrumbObject.length > 1) {
        subCat = breadcrumbObject[breadcrumbObject.length - 1]?.name;
        Cat = breadcrumbObject[1]?.name;
    }

    utag_data = {
        ...utag_data,
        cart_total: cartGrandTotal,
        ip_address: window.BC_CONTEXT?.client_ip_address || '',
        page_name: window.LG_PAGE_DATA?.brand?.name || '',
        total: cartGrandTotal,
        customer_phone: customer?.phone || '',
        customer_city: customer?.shipping_address?.city || '',
        customer_id: customer?.id ? String(customer.id) : '',
        customer_state: customer?.shipping_address?.state || '',
        customer_zip: customer?.shipping_address?.zip || '',
        customer_country: customer?.shipping_address?.country_id || '',
        checkout_step_name: '',
        checkout_step_number: '',
        tealium_event: '404',
        //products_displayed: categoryProductArray,
        page_subcategory: subCat,
        page_category: Cat,
    };
    if (uniqueId != null) {
        utag_data.user_id = uniqueId;
    }
    if (Cat) {
        utag_data.page_category = Cat;
    }
    if (subCat) {
        utag_data.page_subcategory = subCat;
    }

    return utag_data;
}
